import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ErrorOutline } from '@mui/icons-material'
import { Divider, Grid, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import React, { Fragment } from 'react'
import { BlankView } from 'src/Components/blank-view'

const NAME_SPACE = 'systemSettings.grid-and-system-protection-configuration.grid-fault-list'

type Props = {
  errorLogs: string[]
}

const GridFaultList: React.FC<Props> = ({ errorLogs }) => {
  const { t } = useCustomTranslation()

  return (
    <Grid item xs={12}>
      <AccordionItem title={t(`${NAME_SPACE}.title`)}>
        <AccordionContent errorLogs={errorLogs} />
      </AccordionItem>
    </Grid>
  )
}

const AccordionContent: React.FC<{ errorLogs: string[] }> = ({ errorLogs }) => {
  const { t } = useCustomTranslation()

  if (errorLogs.length === 0) {
    return <BlankView imageVariant="HAPPY" title={t(`${NAME_SPACE}.blank-view.title`)} explanation={t(`${NAME_SPACE}.blank-view.explanation`)} />
  }

  return (
    <List sx={{ maxHeight: 300, overflow: 'auto' }}>
      {errorLogs.map((log, index) => (
        <Fragment key={log + index}>
          <ListItem>
            <ListItemIcon>
              <ErrorOutline color="error" />
            </ListItemIcon>
            <ListItemText primary={log} />
          </ListItem>
          <Divider sx={{ borderColor: 'grey.grey05', marginInline: 3 }} />
        </Fragment>
      ))}
    </List>
  )
}

export default GridFaultList
